<template>
  <div v-if="$site.location" class="h-full w-screen bg-secondary flex flex-col">
    <a href="#content" class="fixed -left-full z-[5000] p-2 m-6 rounded border-white bg-black text-white focus:left-1/2 focus:-translate-x-1/2">Skip to main content</a>

    <div id="main" class="relative overflow-y-auto overflow-x-hidden flex-grow flex-shrink sm:pt-20">
      <slot />
    </div>
    
    <LayoutElementsMobile />

    <LayoutElementsMenu />
  </div>
</template>

<script setup lang="ts">
const { $site } = useNuxtApp()

const layoutStore = useLayoutStore()

useHead(() => {
  return {
    htmlAttrs: {
      class: 'layout-mobile'
    },
    bodyAttrs: {
      class: 'bg-secondary'
    }
  }
})

onMounted(() => {
  handleFlutterEvent('routeTo', (event: any) => {
    const route = event?.detail?.route

    if (route) {
      navigateTo(route)
    }
  })

  handleFlutterEvent('toggleMenu', () => {
    layoutStore.menu = !layoutStore.menu
  })

  handleFlutterEvent('refresh', () => {
    window?.location?.reload()
  })
})

/* const emitFlutterEvent = (name, args = {}) => {
  return window?.flutter_inappwebview?.callHandler(name, event)
} */

const handleFlutterEvent = (name: string, callback: Function) => {
  return window?.addEventListener(`bookapp-${name}`, callback, false)
}
</script>

<style>
@supports (-webkit-touch-callout: none) {
  .h-screen {
    height: -webkit-fill-available;
  }
}

.slide-left-leave-active {
  transition: 0.2s;
}
.slide-left-enter-active {
  transition: 0.3s;
}
.slide-left-enter {
  transform: translate(20%, 0);
  opacity: 0
}

.slide-left-leave-to {
  transform: translate(-20%, 0);
  opacity: 0
}

.slide-left-enter-to {
  opacity: 1
}

.slide-right-leave-active
{
  transition: 0.2s;
}
.slide-right-enter-active
{
  transition: 0.3s;
}
.slide-right-enter {
  transform: translate(-20%, 0);
  opacity: 0
}

.slide-right-enter, .slide-right-enter-active {
}

.slide-right-leave, .slide-right-leave-active {
}

.slide-right-leave-to {
  transform: translate(20%, 0);
  opacity: 0
}

.slide-right-enter-to {
  opacity: 1
}
</style>
